var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboFlowOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5238 0.875H0.47619C0.213198 0.875 0 1.09886 0 1.375V2.375C0 2.65114 0.213198 2.875 0.47619 2.875H19.5238C19.7868 2.875 20 2.65114 20 2.375V1.375C20 1.09886 19.7868 0.875 19.5238 0.875Z",
    fill: "#547089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5238 8.00488H0.47619C0.213198 8.00488 0 8.22874 0 8.50488V9.50488C0 9.78103 0.213198 10.0049 0.47619 10.0049H19.5238C19.7868 10.0049 20 9.78103 20 9.50488V8.50488C20 8.22874 19.7868 8.00488 19.5238 8.00488Z",
    fill: "#547089"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5238 15.125H0.47619C0.213198 15.125 0 15.3489 0 15.625V16.625C0 16.9011 0.213198 17.125 0.47619 17.125H19.5238C19.7868 17.125 20 16.9011 20 16.625V15.625C20 15.3489 19.7868 15.125 19.5238 15.125Z",
    fill: "#547089"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboFlowOther);
export default __webpack_public_path__ + "static/media/FBOFlowOther.93d70ad352b432305ee65d4730c08920.svg";
export { ForwardRef as ReactComponent };